import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { clientStore } from 'apps/client/app';
import { Link } from 'core/routing';
import { media } from 'legacyComponents/styled/styleUtils';
import { CardIndicator } from 'legacyComponents/cards/types/indicator';
import {
  Card as BaseCard,
  GreyBar,
  AvatarWrapper,
} from 'legacyComponents/cards/styles';
import { Name as ProfileName } from 'apps/profile/views/profileName.styles';
import {
  Description as ProfileDescription,
  DescriptionWrapper as ProfileDescriptionWrapper,
} from 'apps/profile/views/profileDescription.styles';
import { Center, ProfileUsername } from 'legacyComponents/styled/lib';
import { Avatar } from 'apps/components/shared';
import { Button } from 'components';
import { Follow } from 'apps/content/views/follow';
import PropTypes from 'prop-types';

import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';

import { withNamespaces, Trans } from 'react-i18next';

@withNamespaces()
@observer
export class ProfileCard extends React.Component {
  render() {
    const { cardObject, cardNo, cardColumns } = this.props;

    const noMargin = (cardNo + 1) % cardColumns === 0;
    if (cardObject === null) {
      return <CardIndicator noMargin={noMargin} type='profile' />;
    }
    const {
      avatar,
      imageFallbackPath,
      fullName,
      title,
      username,
      slug,
      bio,
      description,
      content,
    } = cardObject;

    let spaceType = 'profile';
    if (slug) {
      spaceType = 'initiative';
    }

    return (
      <Card noMargin={noMargin}>
        <GreyBar />
        <AvatarWrapper>
          <Link
            name={spaceType}
            params={{ [spaceType]: username || slug }}
            content={content}
          >
            <Avatar
              src={imageSrc(
                avatar,
                imageFallbackPath,
                mainConf.imgSizes.profile.large,
              )}
              size='80px'
              noOpacity={true}
            />
          </Link>
        </AvatarWrapper>
        <Link
          name={spaceType}
          params={{ [spaceType]: username || slug }}
          content={content}
        >
          <Name>{fullName || title}</Name>
        </Link>
        <Link
          name={spaceType}
          params={{ [spaceType]: username || slug }}
          content={content}
        >
          <Username>{username || slug}</Username>
        </Link>
        <DescriptionWrapper>
          <Description>{bio || description}</Description>
        </DescriptionWrapper>
        <ButtonWrapper>
          <Center>
            {username &&
            clientStore.signedInProfile &&
            username === clientStore.signedInProfile.username ? (
              <Link
                name={spaceType}
                params={{ [spaceType]: username }}
                content={content}
              >
                <Button size='small' text={<Trans>Go to Profile</Trans>} />
              </Link>
            ) : (
              <Follow content={content} small />
            )}
          </Center>
        </ButtonWrapper>
      </Card>
    );
  }
}

const Card = styled(BaseCard)`
  height: 255px;
  ${media.s`
    height: 280px;
  `};
  ${media.xs`
    height: 265px;
  `};
`;

const Name = styled(ProfileName)`
  font-size: ${props => props.theme.font.size.default};
  color: ${props => props.theme.color.wfBlack};
  &:hover {
    color: ${props => props.theme.color.primary};
    text-decoration: underline;
  }
`;

const Username = styled(ProfileUsername)`
  font-size: ${props => props.theme.font.size.small};
  margin: ${props => props.theme.spacing.xsmall} 0 0 0;
  &:hover {
    color: ${props => props.theme.color.primary};
    text-decoration: underline;
  }
`;

const DescriptionWrapper = styled(ProfileDescriptionWrapper)`
  margin: ${props =>
    `${props.theme.spacing.default} auto ${props.theme.spacing.medium}`};
  padding: 0 ${props => props.theme.spacing.default};
`;

const Description = styled(ProfileDescription)`
  font-size: ${props => props.theme.font.size.small};
`;

const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.85) 85%,
    rgba(255, 255, 255, 0) 100%
  );
  width: 100%;
  padding: 15px 0px;
`;

ProfileCard.propTypes = {
  cardObject: PropTypes.object,
  cardColumns: PropTypes.number,
  cardNo: PropTypes.number,
};
